<div class="container">
    <div class="title">Ongoing jobs</div>

    <ng-container *ngrxLet="jobsData as data; suspenseTpl: loadingTemplate">
        <ng-container *ngIf="data.uploadDatasetName && data.uploadProgress">
            <div>
                <h3>Upload</h3>
                <div class="uploads">
                    <div class="number font-faded">
                        {{ data.uploadProgress.ratio | percentage }}
                    </div>
                    <div class="font-faded font-smaller">
                        <span class="number">{{ data.uploadProgress.bytesTotal | fileSize }}</span>
                    </div>
                    <div class="file-name" [title]="data.uploadDatasetName">
                        {{ data.uploadDatasetName }}
                    </div>
                </div>
            </div>
        </ng-container>

        <app-job-status-group
            *ngIf="data.cubingJobs.length > 0"
            title="Cubing"
            [jobs]="data.cubingJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.segmentationJobs.length > 0"
            title="Segmentation"
            [jobs]="data.segmentationJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.nucleusExpansionJobs.length > 0"
            title="Nucleus Expansion"
            [jobs]="data.nucleusExpansionJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.registrationJobs.length > 0"
            title="Registration"
            [jobs]="data.registrationJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.recurrentNeighborhoodsJobs.length > 0"
            title="Recurrent neighborhoods"
            [jobs]="data.recurrentNeighborhoodsJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.mapIntensityJobs.length > 0"
            title="Intensity mapping"
            [jobs]="data.mapIntensityJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.neighborhoodEnrichmentJobs.length > 0"
            title="Neighborhood enrichment"
            [jobs]="data.neighborhoodEnrichmentJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.autoCellDetectionJobs.length > 0"
            title="Automatic cell type detection"
            [jobs]="data.autoCellDetectionJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.clusteringJobs.length > 0"
            title="Dimension reduction"
            [jobs]="data.clusteringJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.addMappingPropertiesJobs.length > 0"
            title="Add mapping properties"
            [jobs]="data.addMappingPropertiesJobs"
        ></app-job-status-group>
        <app-job-status-group
            *ngIf="data.plottingJobs.length > 0"
            title="Plotting"
            [jobs]="data.plottingJobs"
        ></app-job-status-group>

        <ng-container
            *ngIf="
                data.cubingJobs.length === 0 &&
                data.segmentationJobs.length === 0 &&
                data.nucleusExpansionJobs.length === 0 &&
                data.registrationJobs.length === 0 &&
                data.recurrentNeighborhoodsJobs.length === 0 &&
                data.mapIntensityJobs.length === 0 &&
                data.neighborhoodEnrichmentJobs.length === 0 &&
                data.autoCellDetectionJobs.length === 0 &&
                data.clusteringJobs.length === 0 &&
                data.plottingJobs.length === 0 &&
                data.addMappingPropertiesJobs.length === 0 &&
                (!data.uploadDatasetName || !data.uploadProgress)
            "
        >
            <div class="center-content">
                <div class="no-content-container">No ongoing jobs</div>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #loadingTemplate>
        <div class="center-content">
            <div class="default-loading-indicator loading-container">
                <cds-progress-circle></cds-progress-circle>
            </div>
        </div>
    </ng-template>
</div>
